import {BANK_ID, ENDPOINT_URL, UNAUTHORIZED, WRONGKEY} from 'constants/index';

const headers = new Headers();
headers.append('Content-Type', 'application/json');
function IsValidJSONString(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}
export const authCallback = (event) => {
	let data = event.data ? event.data : null;

	if (event.data && IsValidJSONString(event.data)) {
		data = JSON.parse(event.data);
	} else {
		return;
	}

	if (data && data.action === 'auth' && data.result === 'OK') {
		window.removeEventListener('message', authCallback);
		localStorage.setItem('authtoken-screening', data.authToken);

		window.location.href = `/test`;
	}
};

export const initAuth = (method, key) => {
	let isOpenIdConnect = false;
	if (method === BANK_ID) {
		isOpenIdConnect = true;
	}

	const payload = {
		isOpenIdConnect,
		method,
		key,
		origin: 'screeningTest',
	};
	// use FORM for OIDC due to cookies not fully synced and. race condition
	if (isOpenIdConnect) {
		const form = document.createElement('form');
		form.method = 'POST';
		form.action = `${ENDPOINT_URL}/initAuthWithKey`;

		Object.entries(payload).forEach(([key, value]) => {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = key;
			input.value = value ?? '';
			form.appendChild(input);
		});
		document.body.appendChild(form);
		form.submit();

		return Promise.resolve();
	}

	// keep existing logic for non-OIDC
	const body = JSON.stringify(payload);
	return fetch(`${ENDPOINT_URL}/initAuthWithKey`, {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers,
		body,
	}).then((response) => {
		if (response.ok) {
			window.addEventListener('message', authCallback);
			return response.json();
		}
		let errorMessage;
		if (response.status === UNAUTHORIZED) {
			errorMessage = 'Ikke gyldig testkode';
		} else if (response.status === WRONGKEY) {
			errorMessage = 'Gyldig testnøkkel, men feil type test';
		} else if (response.statusText) {
			errorMessage = response.statusText;
		} else {
			errorMessage = 'En ukjent feil har skjedd';
		}
		return Promise.reject(errorMessage);
	});
};
